<template>
    <div>
        <div :class="position">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: "BreadcrumbHeaderActionElement",
  data: function () {
    return {
      position: 'header-pos-absolute'

    };
  },
  created(){
    window.addEventListener('scroll', this.changePosition);
  },
  destroyed(){
    window.removeEventListener('scroll', this.changePosition);
  },
  
  methods:{
    changePosition(){
      if (window.scrollY >= 100) {
        this.position = 'header-pos-fixed'
      }
      else {
        this.position = 'header-pos-absolute'
      }
    },
  },
};
</script>

<style>

.header-pos-absolute{
    position: absolute;
    right: 25px;
    top: 105px;
    min-height:100%;
    z-index: 11;
  }

.header-pos-fixed{
    position: fixed;
    right: 25px;
    top: 5px;
    z-index: 11;
}

</style>